import {
  Card as MuiCard,
  CardContent as MuiCardContent,
  CircularProgress,
  MenuItem,
  Select,
  Typography
} from '@mui/material';
import React, {FunctionComponent, useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useAppDispatch, useAppSelector} from '../../../store/hooks';
import {
  getChatgptUsersSelector,
  getClaudeUsersSelector,
  getGithubUsersSelector,
  getGitlabUsersSelector,
  getJiraUsersSelector,
  getNotionUsersSelector,
  getRawSubscriptions,
  getTrelloUsersSelector,
  getUserSelector,
  isChatgptConnect,
  isClaudeConnect,
  isGithubConnect,
  isGitlabConnect,
  isJiraConnect,
  isNotionConnect,
  isShopifyConnect,
  isTrelloConnect,
  loadingUser
} from '../../../store/selectors';
import withRedirectAfterLogout from '../../../utils/withRedirectAfterLogout';
import './style.scss';
import styled from 'styled-components';
import {ArrowRight, Calendar, Check, Database, Mail, RefreshCw} from "react-feather";
import Platform from "../../../models/platforms-data";
import {Button, WhiteCard} from "../../../components/StyledComponents";
import {ETrialStatus} from "../../../models/consts";
import {PlatformsState} from "../../../store/reducers/platform";
import {useNavigate, useSearchParams} from "react-router";
import GithubUserAddEdit from "../../PlatformPages/GithubPages/GithubUserAddEditView/GithubUserAddEdit";
import GitlabUserAddEdit from "../../PlatformPages/GitlabPages/GitlabUserAddEditView/GitlabUserAddEdit";
import TrelloUserAddEdit from "../../PlatformPages/TrelloPages/TrelloUserAddEditView/TrelloUserAddEdit";
import JiraUserAddEdit from "../../PlatformPages/JiraPages/JiraUserAddEditView/JiraUserAddEdit";
import NotionUserAddEdit from "../../PlatformPages/NotionPage/NotionUserAddEditView/NotionUserAddEdit";
import {IUser} from "../../../models/models";
import {
  fetchChatgptUsers,
  fetchClaudeUsers,
  fetchGithubUsers,
  fetchGitlabUsers,
  fetchJiraUser,
  fetchNotionUser,
  fetchShopifyUser,
  fetchTrelloUser,
  getAllSubscriptions,
  updStorageLocation
} from "../../../store/actions";
import {errorBigIcon, iconNotifyWarningInfo, RadioBtn, RadioBtnSelect, toastSuccess} from "../../../assets/icons/icons";
import Swal from "sweetalert2";
import {decoratePopUpMessage} from "../../../utils/popUpTextDecorator";
import {IError} from "../../../models/inner-models";
import {deleteCookie, getCookie, iframeNewTabMsg, iniFrame} from "../../../serviceWorker";
import {clearChoosenAppCookie, getChoosenAppPlatformKey} from "../../../utils/choosenAppCookie";
import {BadgesIFrameMode} from "../../../components/Badges/Badges";
import {getShopifyUsersSelector} from "../../../store/selectors/platformSelectors/getShopifyPlatformSelector";
import ShopifyUserAddEdit from "../../PlatformPages/ShopifyPage/ShopifyUserAddEditView/ShopifyUserAddEdit";
import ChatUserAddEdit from "../../PlatformPages/ChatGPTPages/ChatUserAddEditView/ChatUserAddEdit";
import ClaudeUserAddEdit from "../../PlatformPages/ClaudePages/ClaudeUserAddEditView/ClaudeUserAddEdit";
import {au, de, gb, us} from "../../../assets/icons/flags/flags";
import jiraIcon from "../../../assets/icons/icon-jira.svg";

const env = process.env.STAGE_TYPE;
const ALLOWED_ACTIVE_CAMPAIGN_ENVS = ['prod']

const Card = styled(MuiCard)`
  position: relative;
  margin-bottom: ${(props) => props.theme.spacing(6)};
  border: none;
  border-radius: 8px;
`;

const CardContent = styled(MuiCardContent)`
  position: relative;

  &:last-child {
    padding: 0;
    box-sizing: border-box;
  }
`;

type StepType = {
  step: number;
  stepCur?: number;
  title: string;
  desc: string;
}

const Steps = ({step, stepCur, title, desc}: StepType) => {
  return (
    <div
      className={'newapp-step' + (step === stepCur ? ' active-step' : '') + (stepCur && step < stepCur ? ' done-step' : '')}>
      <div className={'newapp-step-icon' + (stepCur && step < stepCur ? ' done-step' : '')}>
        {stepCur && step >= stepCur ?
          '0' + step :
          <Check/>
        }
      </div>
      <div className='newapp-step-text'>
        <div className='newapp-step-title'>
          {title}
        </div>
        <div className='newapp-step-desc'>
          {desc}
        </div>
      </div>
    </div>
  )
}

const SUPPORTED_STEPS = [1, 2, 3] as const;
const PLATFORMS_WITHOUT_THIRD_STEP = ['chatgpt', 'claude'];
const STEP_THREE_ENTITY_BY_PLATFORM: Record<string, string> = {
  github: 'repository',
  jira: 'project',
  gitlab: 'project',
  notion: 'workspace',
};
const STEP_THREE_OPEN_MODAL_PLATFORMS = ['github', 'gitlab', 'trello'];

const AddApp: FunctionComponent = () => {
  const {t: translate} = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const userLoading = useAppSelector(loadingUser);
  const user: IUser | null = useAppSelector(getUserSelector);
  const [stepCur, setStepCur] = useState<number>(1);
  const [timeLoader, setTimeLoader] = useState<boolean>(false);
  const [selectedApp, setSelectedApp] = useState<string>('');
  const [dataLoad, setDataLoad] = useState<boolean>(true);
  const [userHandLoad, setUserHandLoad] = useState<boolean>(false);
  const [storeSaving, setStoreSaving] = useState<boolean>(false);
  const [storageLoc, setStorageLoc] = useState<string>('US');
  const usersGithub = useAppSelector(getGithubUsersSelector);
  const usersGitlab = useAppSelector(getGitlabUsersSelector);
  const usersTrello = useAppSelector(getTrelloUsersSelector);
  const usersJira = useAppSelector(getJiraUsersSelector);
  const usersNotion = useAppSelector(getNotionUsersSelector);
  const usersShopify = useAppSelector(getShopifyUsersSelector);
  const userChatgpt = useAppSelector(getChatgptUsersSelector);
  const userClaude = useAppSelector(getClaudeUsersSelector);

  const appGithub = useAppSelector(isGithubConnect);
  const appGitlab = useAppSelector(isGitlabConnect);
  const appTrello = useAppSelector(isTrelloConnect);
  const appJira = useAppSelector(isJiraConnect);
  const appNotion = useAppSelector(isNotionConnect);
  const appShopify = useAppSelector(isShopifyConnect);
  const appChatgpt = useAppSelector(isChatgptConnect);
  const appClaude = useAppSelector(isClaudeConnect);

  const platform: PlatformsState | null = useAppSelector(getRawSubscriptions);
  const [activeSub, setActiveSub] = useState<Record<string, string>>({
    github: '',
    trello: '',
    gitlab: '',
    jira: '',
    notion: '',
    shopify: '',
    chatgpt: '',
    claude: '',
  });
  const [searchParams] = useSearchParams();
  const choosenAppFromCookieAppliedRef = useRef(false);

  const storagePlace = {
    DE: translate('views.new_app.storage_regions.de'),
    UK: translate('views.new_app.storage_regions.uk'),
    US: translate('views.new_app.storage_regions.us'),
    AP: translate('views.new_app.storage_regions.ap')
  }
  const storagePlaceFlags = {
    DE: de,
    UK: gb,
    US: us,
    AP: au
  }

  useEffect(() => {
    if (user && !userLoading && env && ALLOWED_ACTIVE_CAMPAIGN_ENVS.includes(env)) {
      const isGoogleSignUp = getCookie('google_sign_up')
      if (isGoogleSignUp) {
        dataLayer.push({
          'event': 'sign_up',
          'method': 'google',
          'user_data': {
            'email': user?.email?.toLowerCase() || ''
          }
        })
        deleteCookie('google_sign_up')
      }
    }
  }, [user, userLoading])

  useEffect(() => {
    const errorMessage = searchParams.get('error_message');
    const warningMessage = searchParams.get('warning_message');
    const confirmGithub = searchParams.get('githubConfirmStatus');
    const iframeJira = searchParams.get('jiraInIframe');

    if (confirmGithub !== null && confirmGithub === 'false') {
      setTimeLoader(true)
      setUserHandLoad(true)
      setStepCur(2);
      setSelectedApp('github')
    }
    if (iframeJira !== null && iframeJira === 'true') {
      setUserHandLoad(true)
      setStorageLoc('')
      setStepCur(1);
      setSelectedApp('jira')
    }

    if (!errorMessage && !warningMessage) {
      return
    }

    Swal.fire({
      imageUrl: errorMessage ? errorBigIcon : iconNotifyWarningInfo,
      title: errorMessage ? translate('notifications.titles.error') : translate('notifications.titles.warning'),
      text: errorMessage ? decoratePopUpMessage(translate('notifications.error_during_connection', {err: errorMessage})) : decoratePopUpMessage(warningMessage as string),
    });
  }, []);

  useEffect(() => {
    const platformFromParams = (searchParams.get('platform') || '').toLowerCase();
    const stepFromParams = Number(searchParams.get('step'));

    if (!platformFromParams || !(platformFromParams in Platform)) {
      return;
    }

    const requestedStep = SUPPORTED_STEPS.includes(stepFromParams as (typeof SUPPORTED_STEPS)[number]) ? stepFromParams : 1;
    const maxStep = PLATFORMS_WITHOUT_THIRD_STEP.includes(platformFromParams) ? 2 : 3;
    const step = Math.min(requestedStep, maxStep);

    setSelectedApp(platformFromParams);
    setStepCur(step);
    setUserHandLoad(step === 2);
  }, [searchParams]);

  const connectApps = {
    github: appGithub,
    trello: appTrello,
    gitlab: appGitlab,
    jira: appJira,
    notion: appNotion,
    shopify: appShopify,
    chatgpt: appChatgpt,
    claude: appClaude,
  }

  const delay = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
  }


  useEffect(() => {
    const fetchData = async () => {
      if (stepCur === 2 && selectedApp && (user?.hadEverAnySubscriptions || selectedApp === 'github')) {
        switch (selectedApp) {
          case 'github':
            await delay(timeLoader ? 10000 : 0)
            await dispatch(fetchGithubUsers()).unwrap().catch(err => console.log(err))
            if (usersGithub) setUserHandLoad(false)
            setTimeLoader(false)
            break;
          case 'gitlab':
            if (usersGitlab) setUserHandLoad(false)
            await dispatch(fetchGitlabUsers()).unwrap().catch(err => console.log(err))
            break;
          case 'trello':
            if (usersTrello) setUserHandLoad(false)
            await dispatch(fetchTrelloUser()).unwrap().catch(err => console.log(err))
            break;
          case 'jira':
            if (usersJira) setUserHandLoad(false)
            await dispatch(fetchJiraUser()).unwrap().catch(err => console.log(err))
            break;
          case 'notion':
            if (usersNotion) setUserHandLoad(false)
            await dispatch(fetchNotionUser()).unwrap().catch(err => console.log(err))
            break;
          case 'shopify':
            if (usersShopify) setUserHandLoad(false)
            await dispatch(fetchShopifyUser()).unwrap().catch(err => console.log(err))
            break;
          case 'chatgpt':
            if (userChatgpt) setUserHandLoad(false)
            await dispatch(fetchChatgptUsers()).unwrap().catch(err => console.log(err))
            break;
          case 'claude':
            if (userClaude) setUserHandLoad(false)
            await dispatch(fetchClaudeUsers()).unwrap().catch(err => console.log(err))
            break;
          default:
            break
        }
        setUserHandLoad(false)
      } else if (!user?.hadEverAnySubscriptions && selectedApp !== 'github' && searchParams.get('githubConfirmStatus') !== 'false') {
        setUserHandLoad(false)
      }
    }
    fetchData();
  }, [stepCur, selectedApp])

  useEffect(() => {
    if (platform && !userLoading && !Object.values(platform)?.filter(i => !i.trial)?.length) {
      Object.keys(platform).forEach(item => {

        if ((!!platform[item].subscription && platform[item].subscription.status === 'active') ||
          platform[item].trial && platform[item].trial.trialStatus === ETrialStatus.STARTED) {
          setActiveSub(prevState => {
            return {
              ...prevState,
              [item]: 'active'
            }
          })
        } else if ((!!platform[item].subscription && platform[item].subscription.status !== 'active') ||
          platform[item].trial && platform[item].trial.trialStatus === ETrialStatus.EXPIRED) {
          setActiveSub(prevState => {
            return {
              ...prevState,
              [item]: 'inactive'
            }
          })
        }
      })
      setDataLoad(false)
    }
  }, [platform, userLoading])

  useEffect(() => {
    if (choosenAppFromCookieAppliedRef.current) return;
    if (userLoading || !platform || dataLoad) return;
    if (user?.hadEverAnySubscriptions) return;
    if (iniFrame()) return;

    const confirmGithub = searchParams.get('githubConfirmStatus');
    const iframeJira = searchParams.get('jiraInIframe');
    if (confirmGithub !== null && confirmGithub === 'false') return;
    if (iframeJira !== null && iframeJira === 'true') return;

    const platformKey = getChoosenAppPlatformKey();
    if (!platformKey || !(platformKey in Platform)) return;

    const plat = platform[platformKey];
    if (!plat?.trial) return;

    choosenAppFromCookieAppliedRef.current = true;
    clearChoosenAppCookie();

    if (plat.trial.trialStatus === 'not started') {
      setStorageLoc('');
    } else {
      setStorageLoc(plat.regionS3);
    }
    setUserHandLoad(true);
    setStepCur(1);
    setSelectedApp(platformKey);
  }, [userLoading, platform, dataLoad, user?.hadEverAnySubscriptions, searchParams]);

  const selectedPlatformTitle = selectedApp && Platform[selectedApp]?.title
    ? Platform[selectedApp].title
    : translate('views.new_app.platform_fallback');
  const hasThirdStep = !PLATFORMS_WITHOUT_THIRD_STEP.includes(selectedApp);
  const stepThreeEntity = STEP_THREE_ENTITY_BY_PLATFORM[selectedApp] || 'board';
  const stepThreeAddText = translate('views.new_app.step3.card_desc_dynamic', {
    entity: stepThreeEntity
  });
  const stepThreeActionText = translate('views.new_app.step3.add_entity', {
    entity: stepThreeEntity
  });
  const stepThreeSearchParams = new URLSearchParams(searchParams);

  if (STEP_THREE_OPEN_MODAL_PLATFORMS.includes(selectedApp)) {
    stepThreeSearchParams.set('openAddModal', 'true');
  }

  const stepsList: StepType[] = [
    {
      step: 1,
      title: translate('views.new_app.steps.step1_title'),
      desc: translate('views.new_app.steps.step1_desc')
    },
    {
      step: 2,
      title: translate('views.new_app.steps.step2_title', {
        platform: selectedPlatformTitle
      }),
      desc: translate('views.new_app.steps.step2_desc', {
        platform: selectedPlatformTitle
      })
    },
    ...(hasThirdStep ? [{
      step: 3,
      title: translate('views.new_app.steps.step3_title', {
        platform: selectedPlatformTitle
      }),
      desc: translate('views.new_app.steps.step3_desc')
    }] : [])
  ];

  const handlePlatformSelect = (name: string) => {
    if (iniFrame()) {
      iframeNewTabMsg();
    }
    if (!connectApps[name]) {
      if (platform[name].trial?.trialStatus === 'not started') {
        setStorageLoc('');
      } else {
        setStorageLoc(platform[name].regionS3);
      }
      setUserHandLoad(true);
      setStepCur(1);
      setSelectedApp(name);
    } else {
      setStorageLoc(platform[name].regionS3);
      setUserHandLoad(true);
      setSelectedApp(name);
      setStepCur(2);
    }
  };

  const product = (prod, name, connected) => {

    return (
      <div
        key={name}
        className={'newapp-item-wrapper ' + `${name}-app`}
        role="button"
        tabIndex={0}
        onClick={() => {
          handlePlatformSelect(name);
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handlePlatformSelect(name);
          }
        }}
      >
        <div className='platformLogoContainer'>
          <img className="platformLogo" src={name === 'jira' ? jiraIcon : prod.smallLogo} loading="lazy"/>
        </div>
        <span className={'newapp-badge newapp-badge--' + (connected ? 'active' : 'inactive')}>
            {connected ? 'Connected' : 'Not Connected'}
          </span>
        <p className='newapp-item-label'>
          {translate('views.new_app.card_label_backup')}
        </p>
        <p className='newapp-item-title'>
          {prod.title}
        </p>
        <div className='newapp-item-arrow' aria-hidden="true">
          <ArrowRight size={16}/>
        </div>
      </div>
    )
  };

  const saveLocation = async () => {
    try {
      setStoreSaving(true)
      let allowUpd = true
      const isRegionChanged = platform[selectedApp].regionS3 !== storageLoc;

      if (platform[selectedApp].trial.trialStatus !== 'not started' && isRegionChanged) {
        await Swal.fire({
          title: translate('notifications.titles.warning'),
          text: translate('views.new_app.change_region_warning'),
          imageUrl: iconNotifyWarningInfo,
          confirmButtonText: translate('notifications.choices.confirm'),
          cancelButtonText: translate('notifications.choices.cancel'),
          showCancelButton: true,
          showLoaderOnConfirm: true,
        })
          .then(res => {
            if (!res.isConfirmed) {
              allowUpd = false
            }
          })
      }

      if (!allowUpd) {
        setStoreSaving(false)
        return
      }
      if (isRegionChanged) {
        await dispatch(updStorageLocation({
          platform: selectedApp,
          region: storageLoc
        })).unwrap()
        Swal.fire({
          title: translate('notifications.titles.success'),
          text: translate('views.new_app.location_saved'),
          toast: true,
          position: 'top-end',
          timerProgressBar: true,
          showConfirmButton: false,
          showCloseButton: true,
          imageUrl: toastSuccess,
          timer: 3000,
        });
        dispatch(getAllSubscriptions()).unwrap()
      }
      setStepCur(2)
      setStoreSaving(false)
    } catch (err) {
      const error = err as IError;
      setStoreSaving(false)
      await Swal.fire({
        title: translate('notifications.titles.error'),
        text: decoratePopUpMessage(error.error as string),
        imageUrl: errorBigIcon,
        confirmButtonText: translate('notifications.choices.close'),
      });
    }
  }

  return (
    <WhiteCard>
      <div id="newapp-page" className={!user?.hadEverAnySubscriptions ? 'container-view' : ''}>
        {userLoading && platform && dataLoad && !!Object.values(platform)?.filter(i => !i.trial)?.length ?
          <div className="spinner-wrapper">
            <CircularProgress/>
          </div> :
          <div className="newapp-block">
            {!user?.hadEverAnySubscriptions ?
              <>
                <Typography variant="h2" display="block" mb='20px'>
                  {translate('common.default_pages.setup_your_first_backup')}
                </Typography>
              </> :
              <Typography variant="h2" display="block" mb='20px'>
                {translate('common.default_pages.app_connector')}
              </Typography>
            }
            {iniFrame() &&
              <BadgesIFrameMode/>
            }
            <div className='newapp-actions'>
              {stepsList.map(item => {
                return (
                  <Steps key={item.step} step={item.step} stepCur={stepCur} title={item.title} desc={item.desc}/>
                )
              })}
            </div>


            {stepCur === 1 && (
              <>
                <div className='newapp-first-app-box'>
                  <div
                    className={'newapp-first-app-box-left' + (selectedApp ? ' newapp-first-app-box-left--selected' : '')}>
                    {!selectedApp ? (
                      <div className='newapp-first-app-empty'>
                        <div className='newapp-first-app-empty-icon'>
                          <Database size={24}/>
                        </div>
                        <p className='newapp-first-app-empty-title'>
                          {user?.hadEverAnySubscriptions ?
                            translate('views.new_app.empty_state_title_new') :
                            translate('views.new_app.empty_state_title')
                          }
                        </p>
                        <p className='newapp-first-app-empty-desc'>
                          {user?.hadEverAnySubscriptions ?
                            translate('views.new_app.empty_state_desc_new') :
                            translate('views.new_app.empty_state_desc')
                          }
                        </p>
                      </div>
                    ) : (
                      <div className='newapp-storage'>
                        <div className='selected-app-head'>
                          <div className='selected-app-logo-wrap'>
                            <img className='selected-app-logo'
                                 src={selectedApp === 'jira' ? jiraIcon : Platform[selectedApp].smallLogo}
                                 loading="lazy"/>
                          </div>
                          <p className='selected-app-title'>
                            {Platform[selectedApp].title}
                          </p>
                        </div>
                        <div className='newapp-storage-sub-text'>
                          {translate('views.new_app.storage_desc')}
                        </div>
                        <Select
                          displayEmpty
                          value={storageLoc}
                          className={!storageLoc ? 'region-select region-select--disabled ' : 'region-select'}
                          MenuProps={{id: 'sub-list-select'}}
                        >
                          <MenuItem value='' key='dis' disabled>
                            {translate('views.new_app.select_region')}
                          </MenuItem>
                          {Object.keys(storagePlace).map(pl => {
                            return (
                              <MenuItem
                                key={pl}
                                value={pl}
                                onClick={() => {
                                  setStorageLoc(pl as string)
                                }}
                              >
                                {pl === storageLoc ? <RadioBtnSelect/> : <RadioBtn/>}
                                <img src={storagePlaceFlags[pl]} loading="lazy"/>
                                {storagePlace[pl]}
                              </MenuItem>
                            )
                          })}
                        </Select>

                        <div className="action-buttons">
                          {platform[selectedApp].trial.trialStatus !== 'not started' && (
                            <Button
                              variant="contained" color="secondary" mr={3}
                              disabled={storeSaving}
                              onClick={() => {
                                if (platform[selectedApp].regionS3 !== storageLoc) {
                                  setStorageLoc(platform[selectedApp].regionS3)
                                }
                                setStepCur(2)
                              }}
                            >
                              Skip
                            </Button>
                          )}
                          <Button
                            variant="contained"
                            color="primary"
                            mr={3}
                            disabled={storeSaving || !storageLoc}
                            onClick={() => {
                              saveLocation()
                            }}
                          >
                            {translate('views.new_app.continue_to_authorization')}
                            <ArrowRight className="feather-icon-in-button icon-ml"/>
                          </Button>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className='newapp-first-app-box-right'>
                    {translate('views.new_app.cloud_data_loss_info')}
                  </div>
                </div>
                <div className='newapp-tools-divider'>
                  <span
                    className='newapp-tools-divider-label'>{!!selectedApp ? translate('views.new_app.tools_divider_label2') : translate('views.new_app.tools_divider_label1')}</span>
                  <span className='newapp-tools-divider-line' aria-hidden="true"/>
                </div>
                <div className='newapp-list-container'>
                  {Object.keys(Platform)
                    .filter(item => item !== selectedApp)
                    .map(item => {
                      return product(Platform[item], item, platform[item]?.isConnectionActive)
                    })
                  }
                </div>
              </>
            )}
            {stepCur === 2 && (
              <Card>
                <CardContent>
                  {userHandLoad ?
                    <div className="spinner-wrapper">
                      <CircularProgress/>
                      {timeLoader && (
                        <div className='spinner-text'>
                          {translate('views.new_app.loading_platform_info', {
                            platform: Platform[selectedApp].title
                          })}
                        </div>
                      )}
                    </div> :
                    <div className='newapp-step-two'>
                      {
                        selectedApp === 'jira' ?
                          <JiraUserAddEdit
                            onClose={() => setStepCur(prevState => prevState - 1)}
                            user={usersJira?.[0]}
                          /> :
                          selectedApp === 'trello' ?
                            <TrelloUserAddEdit
                              onClose={() => setStepCur(prevState => prevState - 1)}
                              user={usersTrello?.[0]}
                            /> :
                            selectedApp === 'gitlab' ?
                              <GitlabUserAddEdit
                                onClose={() => setStepCur(prevState => prevState - 1)}
                                user={usersGitlab?.[0]}
                              /> :
                              selectedApp === 'notion' ?
                                <NotionUserAddEdit
                                  onClose={() => setStepCur(prevState => prevState - 1)}
                                  user={usersNotion?.[0]}
                                /> :
                                selectedApp === 'shopify' ?
                                  <ShopifyUserAddEdit
                                    onClose={() => setStepCur(prevState => prevState - 1)}
                                    user={usersShopify?.[0]}
                                  /> :
                                  selectedApp === 'chatgpt' ?
                                    <ChatUserAddEdit
                                      onClose={() => setStepCur(prevState => prevState - 1)}
                                      user={userChatgpt?.[0]}
                                    /> :
                                    selectedApp === 'claude' ?
                                      <ClaudeUserAddEdit
                                        onClose={() => setStepCur(prevState => prevState - 1)}
                                        user={userClaude?.[0]}
                                      /> :
                                      <GithubUserAddEdit
                                        onClose={() => setStepCur(prevState => prevState - 1)}
                                        user={usersGithub ? usersGithub?.filter(i => i.userType === 'User')?.[0] || usersGithub[0] : {}}
                                      />
                      }
                    </div>
                  }
                </CardContent>
              </Card>
            )}
            {hasThirdStep && stepCur === 3 && (
              <div className='newapp-step-three'>
                <div className='newapp-step-three-left'>
                  <div className='newapp-step-three-title'>
                    {translate('views.new_app.step3.card_title')}
                  </div>
                  <div className='newapp-step-three-desc'>
                    {stepThreeAddText}
                  </div>
                  <div className='newapp-step-three-action-row'>
                    <div className="action-buttons">
                      <Button
                        className='newapp-continue-btn'
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          const searchString = stepThreeSearchParams.toString();
                          navigate(`/platform/dashboard/${selectedApp}${searchString ? `?${searchString}` : ''}`)
                        }}
                      >
                      <span className="newapp-continue-btn-inner">
                        {stepThreeActionText}
                        <ArrowRight className="feather-icon-in-button icon-ml"/>
                      </span>
                      </Button>
                    </div>
                    <div className='newapp-step-three-sub'>
                      {translate('views.new_app.step3.initial_backup_hint')}
                    </div>
                  </div>
                </div>
                <div className='newapp-step-three-right'>
                  <div className='newapp-step-three-right-title'>
                    {translate('views.new_app.step3.what_happens_next')}
                  </div>
                  <div className='newapp-step-three-right-item'>
                    <Calendar size={14}/> {translate('views.new_app.step3.daily_backup')}
                  </div>
                  <div className='newapp-step-three-right-item'>
                    <RefreshCw size={14}/> {translate('views.new_app.step3.restore_options')}
                  </div>
                  <div className='newapp-step-three-right-item'>
                    <Mail size={14}/> {translate('views.new_app.step3.email_reports')}
                  </div>
                </div>
              </div>
            )}
          </div>
        }
      </div>
    </WhiteCard>
  );
};

export default withRedirectAfterLogout()(AddApp);
